import { Box, CheckBox, ColorOptions, IconButton, IconNew, Spacer, Text } from '@jfs/ui-new'
import { View } from 'react-native'
import { amountColumns, settlementFileOptionsExport, settlementFileOptionWithoutCSV } from '../../data/static/data'
import { tableItemStrings } from '../../data/static/strings'
import { ENABLE_CSV, txnCounToDisableXlsx } from '../../util/util'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import { SplitRefundModal } from '../SplitRefundModal'
import { getActionView } from './NewTableItem/getActionView'
import { CopyView } from './NewTableItem/getCopyView'
import { getDownloadDeleteView } from './NewTableItem/getDownloadDeleteView'
import { getEditDownloadView } from './NewTableItem/getEditDeleteView'
import { RefundInvoiceView } from './NewTableItem/RefundInvoiceView'
import { RenderRefuntProcessView } from './NewTableItem/renderRefundProcessView'
import { ActionType } from './NewTableItem/types'
import { UsernameHoverModal } from './UsernameHoverModal'

const CustomCellRenderer = ({
  cellData,
  rowIndex,
  styles,
  onCheckChange,
  isRowChecked,
  tableRef,
  data,
  onAction,
  onDownloadFileAction,
  onChangeInput,
  onInvoiceChange,
  onDownloadReportFile,
  onDeleteReportFile,
  onEditConfig,
  dataKey,
  rowData,
  onRowClick,
  splitActionMenuData,
  isSplitSettlementsEnabled,
}: any) => {
  const handleRowCheckChange = () => {
    if (tableRef) {
      tableRef.current.forceUpdateGrid()
    }
    if (onCheckChange) {
      onCheckChange(!isRowChecked, rowIndex)
    }
  }
  const bgStyle = styles[`${cellData}`?.toLowerCase()] ?? styles.defaultCell
  const textStyles = cellData === '0' ? styles.titleHeader : styles.title

  const handleOnChange = (val: string | number[]): void => {
    console.log('handleOnChange', val)
  }

  const handleDownload = (fileType: string) => {
    if (onDownloadFileAction) {
      onDownloadFileAction(fileType, rowIndex)
    }
  }

  const handleCellPress = () => {
    onRowClick && rowData && onRowClick(rowData)
  }

  const amountActualValue = cellData?.toString()?.replace('₹ ', '')
  const AmountView = (
    <Box
      {...bgStyle}
      justifyContent="center"
      justify={'flex-end'}
      f={1}
      testID={`table-cell-${dataKey}-${rowIndex}`}
      onPress={handleCellPress}
      pr={4}
      w={'100%'}>
      <Box alignItems={'flex-end'} w={120} alignSelf={'flex-start'}>
        <Text {...textStyles} color={styles[`${cellData}`?.toLowerCase()]?.color} textAlign={'right'}>
          {amountActualValue === undefined || amountActualValue === '' ? 'N/A' : `₹ ${amountActualValue}`}
        </Text>
      </Box>
    </Box>
  )

  const defaultView = (isEmptyAllowed: boolean = false) => {
    const actualValue = typeof cellData === 'string' ? cellData?.trim() : cellData
    const placeHolder = isEmptyAllowed ? '' : 'N/A'
    return (
      <Box
        {...bgStyle}
        justifyContent="center"
        f={1}
        testID={`table-cell-${dataKey}-${rowIndex}`}
        onPress={handleCellPress}>
        <Text
          numberOfLines={1}
          {...(tableItemStrings.link.includes(dataKey) ? styles.linkStyle : textStyles)}
          color={
            tableItemStrings.link.includes(dataKey) || dataKey === 'ERN'
              ? 'BLUE'
              : dataKey === 'declined' || (dataKey === 'declinedCount' && actualValue !== 0)
              ? 'RED'
              : styles[`${cellData}`?.toLowerCase()]?.color
          }>
          {typeof cellData !== 'function' &&
            `${actualValue === undefined || actualValue === '' ? placeHolder : actualValue}`}
          {typeof actualValue === 'function' && actualValue(cellData)}
        </Text>
      </Box>
    )
  }

  const executeAction = (actionType: ActionType) => {
    if (onAction) {
      onAction(actionType, data[rowIndex].id)
    }
  }

  const getDownloadOptions = () => {
    if (rowData.settledTransactionCount > txnCounToDisableXlsx && ENABLE_CSV) {
      return settlementFileOptionsExport.filter((item: any) => item.type !== 'XLSX' && item.type !== 'Custom')
    }
    return ENABLE_CSV ? settlementFileOptionsExport : settlementFileOptionWithoutCSV
  }

  const renderTxnDateWithSplitIcon = (data: any) => {
    return (
      <Box flexDirection={'row'} align={'center'} gap={10}>
        {defaultView(false)}
        <Box flexDirection={'row'} minWidth={16}>
          {data?.essStatus === 'PAYOUT_SPLIT_INITIATED' && isSplitSettlementsEnabled && (
            <View style={{ transform: [{ rotate: '90deg' }] }}>
              <IconNew id={'SPLIT'} color={'#9501B0' as ColorOptions} size={16} />
            </View>
          )}
          {data?.refundAmount > 0 && <IconNew id={'ICON_REFRESH'} color={'PRIMARY'} />}
        </Box>
      </Box>
    )
  }

  const renderSplitRefundActionView = () => {
    return <SplitRefundModal data={splitActionMenuData(rowData)} rowData={rowData} />
  }
  const isAmountColumn = amountColumns.includes(dataKey)
  return dataKey === 'refundProcess' ? (
    //getRefundProcessView(cellData, onChangeInput, rowData, isRowChecked)
    <RenderRefuntProcessView
      entry={cellData}
      onChangeInput={onChangeInput}
      data={rowData}
      isRowChecked={isRowChecked}
    />
  ) : dataKey === 'refundInvoiceId' ? (
    <RefundInvoiceView
      data={cellData}
      onInvoiceChange={onInvoiceChange}
      isSodexo={rowData.paymentMode === 'Sodexo'}
      isRowChecked={isRowChecked}
    />
  ) : dataKey === 'refundChannel' ? (
    <UsernameHoverModal data={cellData} rowData={rowData} index={rowIndex} />
  ) : cellData === 'check' ? (
    <CheckBox onChange={handleRowCheckChange} checked={isRowChecked} iconSize={24} />
  ) : cellData === 'EXPORT' ? (
    <DropdownOptimised
      disabled={false}
      placeHolder={'Download'}
      buttonLabel="Download Now"
      data={getDownloadOptions()}
      onChange={handleOnChange}
      onButtonPress={handleDownload}
      type={DropdownTypes.RADIO_BUTTON}
      testID={`downloadInListItem-${rowIndex}`}
      buttonWidth={100}
    />
  ) : cellData === 'EXPORT,DELETE' ? (
    <Box flexDirection={'row'}>
      <DropdownOptimised
        disabled={false}
        placeHolder={'Download'}
        buttonLabel="Download Now"
        data={getDownloadOptions()}
        onChange={handleOnChange}
        onButtonPress={handleDownload}
        type={DropdownTypes.RADIO_BUTTON}
        testID={`table-cell-downloadInListItem-${rowIndex}`}
        buttonWidth={100}
      />
      <Spacer size={10} direction="horizontal" />
      <Box
        borderWidth={1}
        borderColor={'DISABLED_GREY'}
        borderRadius={4}
        height={30}
        alignItems={'center'}
        justifyContent={'center'}>
        <IconButton
          testID={`table-cell-${dataKey}-${rowIndex}`}
          onPress={() => onDeleteReportFile(data[rowIndex])}
          id={'DELETE'}
          size={14}
        />
      </Box>
    </Box>
  ) : dataKey === 'downloadDelete' ? (
    getDownloadDeleteView(data[rowIndex], onDownloadReportFile, onDeleteReportFile, styles.container, rowIndex)
  ) : dataKey === 'url' ? (
    <CopyView itemData={data[rowIndex]} entry={cellData} statusStyle={bgStyle} textStyles={textStyles} />
  ) : dataKey === 'actionDownload' ? (
    getActionView(cellData, executeAction, rowIndex)
  ) : dataKey === 'actionEditDownload' ? (
    getEditDownloadView(data[rowIndex], onEditConfig, onDeleteReportFile, styles.container)
  ) : dataKey === 'transactionDateTime' ? (
    renderTxnDateWithSplitIcon(rowData)
  ) : dataKey === 'splitRefundAction' && splitActionMenuData(rowData)?.length > 0 ? (
    renderSplitRefundActionView()
  ) : isAmountColumn ? (
    AmountView
  ) : (
    defaultView(false)
  )
}

export { CustomCellRenderer }
